const embedClass = '.yt-video-embedding';
const watchNowCtaClass = '.watch-now-cta';

const createYTIframe = (imgEle) => {
  const iframeEle = document.createElement('iframe');
  iframeEle.width = imgEle.width;
  iframeEle.height = imgEle.height;
  iframeEle.setAttribute('loading', 'lazy');
  iframeEle.setAttribute('allowfullscreen', '');
  iframeEle.setAttribute('frameborder', '0');
  iframeEle.setAttribute('allow', 'autoplay');

  return iframeEle;
};

const addUrlToIframe = (url, iframeEle) => {
  iframeEle.setAttribute(
    'src',
    `${url}?autoplay=1&rel=0`,
  );
};

const appendIFramewithUrl = (divEle, iframeEle, url) => {
  divEle.appendChild(iframeEle);
  addUrlToIframe(url, iframeEle);
};

const embedYTElement = (divEle, imgEle, embedType) => {
  if (divEle && imgEle) {
    if (embedType === 'onclick') {
      imgEle.addEventListener('click', () => {
        if (!divEle.querySelector('iframe')) {
          const iframeEle = createYTIframe(imgEle);
          imgEle.classList.add('hidden');
          divEle.classList.add(divEle.dataset.class);
          divEle.appendChild(iframeEle);
          appendIFramewithUrl(divEle, iframeEle, imgEle.dataset.url);
        }
      });
    } else if (!divEle.querySelector('iframe')) {
      const iframeEle = createYTIframe(imgEle);
      imgEle.classList.add('hidden');
      divEle.classList.add(divEle.dataset.class);
      divEle.appendChild(iframeEle);
      appendIFramewithUrl(divEle, iframeEle, imgEle.dataset.url);
    }
  }
};

const embedYTContainer = (eleContainer, watchNowEle) => {
  eleContainer.forEach(ele => embedYTElement(
    ele, ele.querySelector(':scope > img'), 'onclick',
  ));

  watchNowEle.forEach((ele) => {
    ele.addEventListener('click', () => {
      const { videoClass } = ele.dataset;

      if (videoClass) {
        const divEle = document.getElementsByClassName(videoClass)?.[0];
        const imgEle = divEle.querySelector(':scope > img');
        embedYTElement(divEle, imgEle);
      }
    });
  });
};

const initialize = () => {
  embedYTContainer(document.querySelectorAll(embedClass),
    document.querySelectorAll(watchNowCtaClass));
};

export default {
  initialize,
};
